export default {
  boutiqueList: {
    title: 'Shop',
    titleRestro: 'Shop'
  },
  productsView: {
    title: 'Products',
    subtitle1: "Agency's products are available in full case.",
    subtitle2: 'The number of bottles per case may vary.',
    description: "According to the law governed by the SAQ, products sold through Private Importation are only available at the checkout.",
  },
  productView: {
    label: {
      available: 'Available',
      notAvailable: 'Sold Out',
      similarProducts: 'Similar products',
      privateAvailable: 'Avail in private',
      privateNotAvailable: 'Sold Out',
    },
  },
  productCardComponent: {
    quantity: 'QTY',
    boxOf: 'Box (x{numberOfBottle})',
  },
  filters: {
    label: {
      selectedFilters: 'Filters',
      all: 'All',
      headers: {
        typeOfProduct: 'Type of product',
        price: 'Price',
        particularities: 'Color',
        availability: 'Warehouses',
        product_status: 'Availability',
        countryRegion: 'Origin',
      },
    },
    validation: {
      priceNovalue: 'Value required',
      priceNotANumber: 'Must be numreric value',
      priceLessThanZero: 'Must be greater than or equals to 0',
    },
    button: {
      cancel: 'Cancel',
      filter: 'Filter',
    },
    noRecordsFound: 'No records found',
  },
  addToCart: {
    title: {
      price: 'Price',
      taxLabel: {
        IN: 'Tax in',
        OUT: 'Tax ex',
      },
    },
    label: {
      addToCart: 'Add to cart',
      howToOrder: 'How to order from SAQ ?',
      availableInStore: 'Available in Shop',
      purchase: '-15% for 500$ of purchase',
      notAvailable: 'Sold Out',
      purchaseMember: '-20% for members',
      quantity: 'Quantity',
      addedToCart: 'Added to cart',
      buy: 'Buy',
      reserve: 'Reserve',
      reserved: 'Reserved',
    },
    labelDescription: {
      howToOrder: 'Go to the SAQ website at <a href="www.saq.com" style="color:#a31c25">www.saq.com</a> and select the desired product. You will find the branches that hold the product and the number of bottles available. You will also be able to see which products are available for sale online and for delivery.',
      pickupInsaq: 'According to the rules governed by the Saq, products sold through private importation are exclusively available in full cases.',
    }
  },
  boutiqueProductsView: {
    title: "Shop",
    subtitle1: "Items are sold individually in the shop.",
    subtitle2: '',
    description: 'Our shops operate as Shop and are governed by the act respecting liquor permits. For more information, we invite you to read the text of law: <a target="_blank" href="https://www.legisquebec.gouv.qc.ca/en/document/cs/P-9.1?langCont=en#se:26):~:text=The%shop%20permit%20also%20authorizes%20the%20sale%2C%20for%20take%20out%20or%20delivery%20in%20a%20sealed%20container%2C%20of%20alcoholic%20beverages%20other%20than%20alcohol%20and%20spirits%20if%20such%20beverages%20are%20sold%20with%20food%20prepared%20by%20the%20permit%20holder." style="color:#a31c25">P-9.1 - Act respecting liquor permits</a>'
  },
  boutiqueProductsQuebecView: {
    title: "Quebec Shop",
    subtitle1: "Items are sold individually in the shop.",
    subtitle2: '',
    description: 'Our shops operate as Shop and are governed by the act respecting liquor permits. For more information, we invite you to read the text of law: <a target="_blank" href="https://www.legisquebec.gouv.qc.ca/en/document/cs/P-9.1?langCont=en#se:26):~:text=The%20shop%20permit%20also%20authorizes%20the%20sale%2C%20for%20take%20out%20or%20delivery%20in%20a%20sealed%20container%2C%20of%20alcoholic%20beverages%20other%20than%20alcohol%20and%20spirits%20if%20such%20beverages%20are%20sold%20with%20food%20prepared%20by%20the%20permit%20holder." style="color:#a31c25">P-9.1 - Act respecting liquor permits</a>'
  },
  boutiqueProductsTorontoView: {
    title: "Shop",
    title1: "Shop",
    subtitle1: "Items are sold individually in the shop.",
    subtitle2: '',
    description: 'Our shops operate as Shop and are governed by the act respecting liquor permits. For more information, we invite you to read the text of law: <a target="_blank" href="https://www.agco.ca/bulletin/2020/information-bulletin-highlights-recent-liquor-reforms-support-businesses#changes:~:text=Regulation%20719%20under%20the%20Liquor%20Licence%20Act%20(LLA)%20has%20been%20amended%20to%20permanently%20allow%20eligible%20liquor%20sales%20licensees%20to%20offer%20the%20sale%20of%20liquor%20with%20food%20for%20takeout%20and%20delivery%20orders.%20Related%20amendments%20for%20liquor%20delivery%20service%20licensees%20have%20also%20been%20made%20to%20Regulation%20718." style="color:#a31c25">P-9.1 - Act respecting liquor permits</a>'
  },
  deliveryAddress: {
    montreal: 'Pick-up in Shop - Free 6422 Boul. Saint-laurent, local 102 Montréal, QC - H2S 3C4',
    quebec: 'Ramassage en Shop - Gratuit 281 rue de la Couronne Québec, QC - G1K 6E2',
    toronto: 'Pick-up in Shop - Free 1583 Dupont Toronto, ON, M6P 3S5',
    tagLine: 'Livraison chez vous - Frais de livraison en sus'
  },
  pickupAddress: {
    montreal: 'Livraison chez vous - Frais de livraison en sus <br>Bientôt disponible',
    quebec: 'Livraison chez vous - Frais de livraison en sus <br>Bientôt disponible'
  },
  listTypeViewHeading: {
    title: 'No title',
    type: 'Type',
    disponibilité: 'Disponibilité',
    nom: 'Name',
    cepage: 'Cépage',
    annee: 'Year',
    producteur: 'Producteur',
    production: 'Production',
    qte: 'Min. qty',
    prix: 'Price',
    TBD: 'À venir',
    productCardComponent: {
      quantity: 'QTE',
      boxOf: '{numberOfBottle}',
    },
    volume: 'volume'
  },
  nextBatche: {
    date: 'Date',
    Quantity: 'Quantité',
    name: 'Nom',
  },
  Apply: 'Apply',
  productAvailabilityTreeData: {
    IP: 'Private Import'
  },
  productListView: {
    label: {
      available: 'Avail',
      notAvailable: 'Sold Out',
    },
  },
  productAvailabilityTreeDataQc: [
    {
      id: 2,
      name: 'SAQ',
      code: 'SAQ',
    },
    {
      id: 3,
      name: 'IP',
      code: 'IP',
    },
    {
      id: 4,
      name: 'Boires',
      code: 'boires'
    },
  ],
  productAvailabilityStatusTree: [
    {
      id: 1,
      name: 'Available',
      code: 'AVAILABLE',
    },
    {
      id: 2,
      name: 'Coming soon',
      code: 'UPCOMING',
    },
  ],
  productAvailabilityTreeDataOn: [
    {
      id: 2,
      name: 'LCBO',
      code: 'LCBO',
    },
    {
      id: 3,
      name: 'Consignment',
      code: 'PI',
    },
    {
      id: 4,
      name: 'Boires',
      code: 'MERCH_TORONTO',
    },
    
  ],
  addToCartPopup: {
    title: 'Added to cart',
    seeCart: 'See cart',
    shopping: 'Continue shopping',
    thanksMessage: 'Thank you',
    reserveContent: 'Your reservation for a “upcoming" product has been sent to the Boires agency team. You will soon be contacted by email to confirm this reservation.',
  },
  reservePopup: {
    title: 'Add to reservation',
    subtitle: 'I confirm that I wish to reserve the upcoming wine',
    reserveButton: 'Reserve',
    cancelButton: 'I do not wish to reserve',
  },
  deliveryOption: 'Delivery Option',
  SaqPick: 'Pick up in Saq branch / Pick up in Saq Shop.',
  case: 'By the case',
  caisse: 'Box',
  units: 'Unit',
  each: 'each',
};